<template>
  <div class="table-container">
    <div class="b-table-sticky-header table-responsive et__table">
      <DataTable
        id="table"
        :items="items"
        :fields="fields"
        :sort-desc="sortDesc"
        :sort-by="sortBy"
        :per-page="perPage"
        :current-page="currentPage"
        sticky-header
        hover
        bordered
        small
        responsive
        no-sort-reset
        @input="$emit('sortChanged', $event)"
      />
    </div>

    <BPagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="table"
    />
  </div>
</template>

<script>
import { DataTable } from '@ui/components'
import { BPagination } from '@ui/components'

const DEFAULT_ROWS_BY_PAGE = 20

export default {
  components: {
    DataTable,
    BPagination
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    sortBy: { // sort by this field initially
      type: String,
      default: ''
    },
    sortDesc: {
      type: Boolean,
      default: true
    },
    perPage: {
      type: Number,
      default: DEFAULT_ROWS_BY_PAGE
    }
  },
  emits: ['sortChanged'],
  data() {
    return {
      currentPage: 1
    }
  },
  computed: {
    rows() {
      return this.items.length
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@ui/styles/src/scss/utils/lib";

$stickyColumnColor: #edeff2;

.table-container {
  @extend %flex-column;

  overflow: hidden;
}

:deep(.et__table) {
  max-height: 100%;
  border-bottom: 1px solid #b5b5b5;

  table.table { // needed to add .table class to override other styles
    margin-bottom: 0;
    border-collapse: separate;
    border-spacing: 0;
  }

  thead {
    th {
      position: sticky;
      top: 0;
      z-index: 2;
      min-width: 150px;
      padding: 0.45rem;
      padding-right: 1rem; // prevent overlap between text and sort arrows
      vertical-align: middle;
      background-color: #fff;

      &[aria-sort] {
        cursor: pointer;

        &:focus {
          outline: none;
        }
      }

      &:last-child {
        position: sticky;
        top: 0;
        right: 0;
        width: 180px;
        background-color: $stickyColumnColor;
        border-left-width: 2px;
      }

      &:not(:last-child) {
        border-right: none;
      }
    }
  }

  tbody {
    td {
      min-width: 150px;
      padding: 0.45rem;
      border-top: none;

      &:not(:last-child) {
        border-right: none;
      }

      &:last-child {
        position: sticky;
        right: 0;
        text-align: right;
        background-color: $stickyColumnColor;
        border-left-width: 2px;
      }
    }
  }
}
</style>
